<template>
	<ul class="related-tasks__list" :class="listClasses">
		<li class="related-tasks__item" :class="{ 'related-tasks__item--related': relatedOnly }" v-for="task in tasks">
			<a :href="task.url" target="_blank">
				<img :src="task.avatar" :alt="task.username">
				<i class="icon" :class="`icon-${parseInt(task.finished) ? 'check' : 'refresh-cw'}`" :title="`${parseInt(task.finished) ? 'Finished' : 'Activated'}`" v-if="!task.isLoader"></i>
				<span class="overflow-truncate">{{ task.title }}</span>
			</a>
		</li>
	</ul>
</template>

<script>
export default {
	name: 'related-tasks-list',

	props: {
		tasks: {
			default: [],
			type: Array,
		},
		relatedOnly: {
			default: false,
			type: Boolean
		},
		archivedOnly: {
			default: false,
			type: Boolean
		}
	},
	computed: {
		/**
		 * List classes.
		 *
		 * @return {Object}
		 */
		listClasses() {
			return {
				'related-tasks__list--archived': this.archivedOnly,
				'related-tasks__list--related': this.relatedOnly
			}
		}
	}
}
</script>
